module.exports = __webpack_public_path__ + "static/media/mz 1.23bd70d4.png";